declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

/** Fire GA4 register_click with section source for attribution */
export function trackRegisterClick(source: string, label?: string) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', 'register_click', {
    click_source: source,
    ...(label ? { link_label: label } : {}),
  });
}
